import { createReducer } from '@reduxjs/toolkit'

import types from './types'

export { default as actions } from './actions'

export default createReducer(
  {},
  {
    [types.UPDATE_SAVED_SEARCH]: (state, action) => action.payload,
    [types.CLEAR_SAVED_SEARCH]: (state, action) => action.payload,
  },
)
